import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "src/app/common/officeSelector/officeSelector.service";
import { KpiService } from "src/app/dashboardCommon/services/kpiService";
import { WorkersAppealKpiCfg, WorkersAppealKpiCfgService } from "./workersAppealKpiCfg.service";
import { KpiServiceError, KpiServiceErrorType } from "src/app/dashboardCommon/services/kpiServiceError";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class WorkersAppealServiceData {
    public consultant: number;
    public office: number;
    public updateTimestamp: Date;
}

@Injectable()
export class WorkersAppealService extends KpiService<WorkersAppealServiceData> {
    public getClassName(): string {
        return "WorkersAppealService";
    }

    constructor(
        private serviceCfg: WorkersAppealKpiCfgService,
        private apigeeService: ApigeeService,
        private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ){
        super(injector);
    }

    protected async update(): Promise<WorkersAppealServiceData> {
        if (this.apigeeService.apiToken){
            let result: WorkersAppealServiceData = null;
            try {
                let cfg: WorkersAppealKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.workersAppeal.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.post<WorkersAppealServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }

}
